import React, {useEffect, useMemo} from "react";
import {Badge, Button, Row} from "antd";
import {useGetIssuesHomepageNewReleasesQuery} from "@mwServices/Issue";
import BookCover from "@components/book-cover";
import {getMostResentReleaseDate} from "@lib/utils";
import {formatDateTiny} from "@lib/format";
import formatNodeAssertErrors from "jest-circus/build/formatNodeAssertErrors";

const HomePageNewReleases = ({windowDimensions, onLoad}) => {

    const newReleaseQuery = useGetIssuesHomepageNewReleasesQuery({});

    const issues = useMemo(() => {
        if(newReleaseQuery.data && newReleaseQuery.data.issues) {
            if(windowDimensions.over(799)) {
                return newReleaseQuery.data.issues.slice(0,14);
            } else {
                return newReleaseQuery.data.issues.slice(0,6);
            }
        }
        return [];
    }, [newReleaseQuery, windowDimensions]);

    useEffect(() => {
        if(newReleaseQuery.data) onLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newReleaseQuery]);

    const newReleaseDate = useMemo(() => {
        let date:any = newReleaseQuery?.data?.date;
        return newReleaseQuery.data ? formatDateTiny(new Date(date)) : '';
    }, [newReleaseQuery])

    return (
        <div className="homepage-issues mar-bot-15">
            <h2 >New Releases - {newReleaseDate}</h2>

            <div style={{width: '100%', display: 'flex'}}>
                <div className="issues-grid">
                    {issues.map((issue,i) => (
                        <div key={i} className={"issues-item"}>
                            <a href={`/issue/${issue.slug}`}>
                                <BookCover issue={issue} preview={false}/>
                            </a>
                            <div className="homepage-item-title mar-top-5">
                                {issue.series_title} {issue.issue_number}
                            </div>
                            <div className="homepage-item-subtitle">
                                {issue.variant_name}
                            </div>
                        </div>
                    ))}
                </div>
            </div>


            <Row justify="center" >
                <Button className="homepage-section-big-button mar-top-20" href="/new-releases">View All New Releases</Button>
            </Row>
        </div>
    );
};

export default HomePageNewReleases;